import React, { useState } from 'react';
import Seo from '../components/seo/Seo';
import { breadcrumbSchema } from '../components/seo/jsonld';

const SUPPORT_EMAIL = 'pdf2convertor@gmail.com';

const ContactPage = () => {
    const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, email, subject, message } = form;

        if (!name.trim() || !email.trim() || !message.trim()) {
            setStatus('Please fill in your name, email, and message.');
            return;
        }

        const body = [
            `From: ${name} <${email}>`,
            '',
            message,
        ].join('\n');

        const mailto =
            `mailto:${SUPPORT_EMAIL}` +
            `?subject=${encodeURIComponent(subject || 'Enquiry from pdfconvertor.shop')}` +
            `&body=${encodeURIComponent(body)}`;

        window.location.href = mailto;
        setStatus('Opening your email app… if nothing happens, please email us directly.');
    };

    return (
        <>
            <Seo
                title="Contact Us"
                description="Contact pdfconvertor.shop. Report bugs, request features, or ask about privacy. We aim to reply within a few business days."
                path="/contact"
                jsonLd={breadcrumbSchema([
                    { name: 'Home', path: '/' },
                    { name: 'Contact', path: '/contact' },
                ])}
            />

            <div className="page-container narrow">
                <article>
                    <header className="page-header">
                        <h1>Contact Us</h1>
                        <p className="page-lead">
                            Bug reports, feature requests, and privacy questions all welcome.
                            We read everything.
                        </p>
                    </header>

                    <section className="content-section">
                        <div className="contact-grid">
                            <div>
                                <h2>Email</h2>
                                <p>
                                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                                </p>

                                <h2>Mailing address</h2>
                                <p>
                                    KPHB 7th Phase, KPHB<br />
                                    Hyderabad, Telangana<br />
                                    India
                                </p>

                                <h2>Response time</h2>
                                <p>
                                    We try to reply within 3&ndash;5 business days. For urgent
                                    privacy or takedown requests, please put
                                    &quot;<strong>PRIVACY</strong>&quot; at the start of the
                                    subject line so we can prioritize.
                                </p>
                            </div>

                            <form className="contact-form" onSubmit={handleSubmit} noValidate>
                                <h2>Send a message</h2>

                                <label htmlFor="name">Your name</label>
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    autoComplete="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />

                                <label htmlFor="email">Email address</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                />

                                <label htmlFor="subject">Subject</label>
                                <input
                                    id="subject"
                                    name="subject"
                                    type="text"
                                    value={form.subject}
                                    onChange={handleChange}
                                />

                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="6"
                                    value={form.message}
                                    onChange={handleChange}
                                    required
                                />

                                <button type="submit" className="btn-primary">
                                    Open in email app
                                </button>

                                {status && <p className="form-status">{status}</p>}

                                <p className="form-note">
                                    This form composes an email in your default mail app — we
                                    don't run a server for contact submissions, so your message
                                    isn't sent from the browser. Alternatively, email us
                                    directly at{' '}
                                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
                                </p>
                            </form>
                        </div>
                    </section>
                </article>
            </div>
        </>
    );
};

export default ContactPage;
